import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { cva } from 'class-variance-authority';

export type CalibrationDeviceRailStatus = 'active' | 'none';

export const CALIBRATION_DEVICE_RAIL_STATUS_MESSAGES: Record<
  CalibrationDeviceRailStatus,
  MessageDescriptor
> = {
  active: msg`Active`,
  none: msg`None`,
};

export const calibrationDeviceRailScrollVariants = cva(
  'scrollbar-thin-stable min-h-0 flex-1 overflow-y-auto overscroll-contain px-1.5 pb-2 outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-ring',
);
export const calibrationDeviceRailListVariants = cva('relative');
export const calibrationDeviceRailStationVariants = cva(
  'flex h-7 w-full items-center gap-1 rounded-md px-0.5 text-left text-xs outline-none transition-colors hover:bg-sidebar-accent focus-visible:ring-1 focus-visible:ring-sidebar-ring',
  {
    variants: { expanded: { true: 'bg-sidebar-accent/60', false: null } },
    defaultVariants: { expanded: false },
  },
);
export const calibrationDeviceRailBranchVariants = cva(
  'ml-3.5 border-sidebar-border/80 border-l pl-2',
  {
    variants: {
      edge: { first: 'pt-0.5', middle: null, last: 'mb-0.5 pb-0.5', only: 'mb-0.5 py-0.5' },
    },
    defaultVariants: { edge: 'middle' },
  },
);
export const calibrationDeviceRailDeviceVariants = cva(
  'flex h-6 min-w-0 items-center gap-1.5 rounded-md px-1.5 text-xs text-muted-foreground outline-none transition-colors hover:bg-sidebar-accent/70 hover:text-foreground focus-visible:ring-1 focus-visible:ring-sidebar-ring',
  {
    variants: {
      active: { true: 'bg-sidebar-accent font-medium text-sidebar-accent-foreground', false: null },
    },
    defaultVariants: { active: false },
  },
);
export const calibrationDeviceRailStatusVariants = cva(
  'shrink-0 rounded-full px-1.5 py-0.5 font-medium text-[10px] leading-none',
  {
    variants: {
      status: {
        active: 'bg-primary/10 text-primary/80',
        none: 'bg-muted/70 text-muted-foreground/80',
      } satisfies Record<CalibrationDeviceRailStatus, string>,
    },
    defaultVariants: { status: 'none' },
  },
);
